import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import CruzeAdminTable from "./CruzeAdminList";
import CruzeAdminModal from "./CruzeAdminModal";
import AdminServices from "../services/externalServices/adminServices";

/**
 * Parent page for managing Cruze Admins
 */
const CruzeAdminPage = () => {
  const [admins, setAdmins] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  /* ================= FETCH ADMINS ================= */
  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
    try {
      const response = await AdminServices.getAllAdmins();
      setAdmins(response);
    } catch (err) {
      console.error("Failed to fetch admins", err);
    }
  };

  /* ================= OPEN MODAL ================= */
  const handleAdd = () => {
    setSelectedAdmin(null);
    setOpenModal(true);
  };

  const handleEdit = (admin) => {
    setSelectedAdmin(admin);
    setOpenModal(true);
  };

  /* ================= SAVE ADMIN ================= */
  const handleSave = async (formData) => {
    try {
      if (formData._id) {
        // 🔄 UPDATE
        console.log("Updating admin:", formData);
        await AdminServices.updateAdmin(formData._id, formData);
      } else {
        // ➕ CREATE
        await AdminServices.createAdmin(formData);
      }

      setOpenModal(false);
      setSelectedAdmin(null);
      fetchAdmins(); // refresh list
    } catch (err) {
      console.error("Save failed", err);
    }
  };

  return (
    <Box p={3}>
      {/* Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h5" fontWeight={600}>
          Cruze Admin Management
        </Typography>

        <Button variant="contained" onClick={handleAdd}>
          Add Admin
        </Button>
      </Box>

      {/* Table */}
      <CruzeAdminTable admins={admins} onEdit={handleEdit} />

      {/* Modal */}
      <CruzeAdminModal
        open={openModal}
        admin={selectedAdmin}
        onClose={() => setOpenModal(false)}
        onSave={handleSave}
      />
    </Box>
  );
};

export default CruzeAdminPage;
